import { render, staticRenderFns } from "./modifyPriceModal.vue?vue&type=template&id=24f5c010&scoped=true"
import script from "./modifyPriceModal.vue?vue&type=script&lang=js"
export * from "./modifyPriceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f5c010",
  null
  
)

export default component.exports